import { render, staticRenderFns } from "./PotentialWorkerSkillsTable.vue?vue&type=template&id=0b19dad7&scoped=true&"
import script from "./PotentialWorkerSkillsTable.vue?vue&type=script&lang=js&"
export * from "./PotentialWorkerSkillsTable.vue?vue&type=script&lang=js&"
import style0 from "./PotentialWorkerSkillsTable.vue?vue&type=style&index=0&id=0b19dad7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19dad7",
  null
  
)

export default component.exports